export function getEmailLocalStorage() {
    if (localStorage.getItem('userEmail')) {
        return localStorage.getItem('userEmail')
    } else {
        return null
    }
}
